/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

// "Dicci la tua" (migrazione 016): il questionario e i problemi con l'app.
export const feedbackAPI = {
  mio: async () => {
    const { data } = await apiClient.get('/feedback/mio');
    return data;
  },

  invia: async (payload) => {
    const { data } = await apiClient.post('/feedback', payload);
    return data;
  },
};

// I problemi con l'APP (non con l'impianto): segnalazioni di tipo bug, solo
// testo. Il cliente vede e commenta solo le proprie.
export const problemiAPI = {
  list: async () => {
    const { data } = await apiClient.get('/segnalazioni', { params: { stato: 'tutte' } });
    return data;
  },

  detail: async (id) => {
    const { data } = await apiClient.get(`/segnalazioni/${id}`);
    return data;
  },

  crea: async (titolo, descrizione) => {
    const { data } = await apiClient.post('/segnalazioni', { titolo, descrizione });
    return data;
  },

  commenta: async (id, commento) => {
    const { data } = await apiClient.post(`/segnalazioni/${id}/commenti`, { commento });
    return data;
  },
};
